<div class="create-opportunity-container d-flex flex-column">
    <div class="dialog-body">
        <div class="row" [formGroup]="createOpportunityFormGroup">
            <div class="col-md-6">
                <mat-radio-group formControlName="opportunityType">
                    <mat-radio-button color="primary" value="baseOrder" disabled>{{'BASE_ORDER' | translate}}</mat-radio-button>
                    <mat-radio-button color="primary" value="changeOrder" disabled>{{'CHANGE_ORDER' | translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-md-6"></div>
        </div>
        <div class="row" [formGroup]="createOpportunityFormGroup">
            <div class="col-md-6">
                <fieldset class="border rounded-3 p-2">
                    <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'ESTIMATE' | translate}}</legend>
                    <div class="row">
                        <div class="col-md-2">{{'ID' | translate}}:</div>
                        <div class="col-md-10 control-align">
                            <div class="hover-wrapper"
                                (mouseenter)="showHoverCard='estimate'"
                                (mouseleave)="showHoverCard=''">
                                <mat-form-field appearance="outline" class="estimate-id-field">
                                    <input matInput formControlName="estimateId" [disabled]="isEstimateIdDisabled">
                                </mat-form-field>
                                @if(showHoverCard === 'estimate' && canShowPopup('estimate')) {
                                    <app-crm-entity-details-popup
                                        [title]="getPopupTitle('estimate')"
                                        [rows]="getPopupRows('estimate')"
                                        class="hover-popup">
                                    </app-crm-entity-details-popup>
                                }
                            </div>
                            <button mat-raised-button color="primary" [disabled]="estimateButtonStates.searchDisabled" (click)="searchEstimate()">...</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{'NAME' | translate}}:</div>
                        <div class="col-md-10 control-align gap-4">{{ estimateInfoForOpportunity?.estimateName }}
                            <button class="ml-auto" mat-raised-button color="primary" [disabled]="estimateButtonStates.verifyDisabled" (click)="verifyEstimate()">{{'VERIFY' | translate}}</button>
                        </div> 
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-2">
                    <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'BASE_OPPORTUNITY' | translate}}</legend>
                    <div class="row">
                        <div class="col-md-2">{{'ID' | translate}}:</div>
                        <div class="col-md-10 control-align">
                            <div class="hover-wrapper"
                                (mouseenter)="showHoverCard='baseOpportunity'"
                                (mouseleave)="showHoverCard=''">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="baseOpportunity">
                                </mat-form-field>
                                @if(showHoverCard === 'baseOpportunity' && canShowPopup('baseOpportunity')) {
                                    <app-crm-entity-details-popup
                                        [title]="getPopupTitle('baseOpportunity')"
                                        [rows]="getPopupRows('baseOpportunity')"
                                        class="hover-popup">
                                    </app-crm-entity-details-popup>
                                }
                            </div>
                            <button mat-raised-button color="primary" [disabled]="isFormDisabled || baseOpportunityDisabled || baseOpportunityButtonStates.searchDisabled" (click)="searchBaseOpportunity()">...</button>
                            <button mat-raised-button color="primary" [disabled]="isFormDisabled || baseOpportunityDisabled || baseOpportunityButtonStates.verifyDisabled" (click)="verifyBaseOpportunity()">{{'VERIFY' | translate}}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{'NAME' | translate}}:</div>
                        <div class="col-md-10">{{ opportunityModel?.opportunityName }}
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-2">
                    <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'ACCOUNT_NAME' | translate}}</legend>
                    <div class="row">
                        <div class="col-md-2">{{'ID' | translate}}:</div>
                        <div class="col-md-10 control-align">
                            <div class="hover-wrapper"
                                (mouseenter)="showHoverCard='accountName'"
                                (mouseleave)="showHoverCard=''">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="accountName">
                                </mat-form-field>
                                @if(showHoverCard === 'accountName' && canShowPopup('accountName')) {
                                    <app-crm-entity-details-popup
                                        [title]="getPopupTitle('accountName')"
                                        [rows]="getPopupRows('accountName')"
                                        class="hover-popup">
                                    </app-crm-entity-details-popup>
                                }
                            </div>
                            <button mat-raised-button color="primary" (click)="searchCustomer(CustomerSearchType.AccountName)" [disabled]="isFormDisabled || customerAccountsDisabled || customerButtonStates.accountName.searchDisabled">...</button>
                            <button mat-raised-button color="primary" (click)="verifyCustomer(CustomerSearchType.AccountName)" [disabled]="isFormDisabled || customerAccountsDisabled || customerButtonStates.accountName.verifyDisabled">{{'VERIFY' | translate}}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{'NAME' | translate}}:</div>
                        <div class="col-md-10">{{ accountNameData.customerName }}
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-2">
                    <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'SHIP_TO_LOCATION' | translate}}</legend>
                    <div class="row">
                    <mat-checkbox class="sold-to-checkbox" [checked]="isApplySoldToChecked('shipToLocation')" [disabled]="!hasSoldToAccountSelected()" 
                    (change)="onApplySoldToChange('shipToLocation', $event.checked)" color="primary">{{ 'APPLY_SOLD_TO_ACCOUNT' | translate }}</mat-checkbox>
                </div>
                <div class="row">
                        <div class="col-md-2">{{'ID' | translate}}:</div>
                        <div class="col-md-10 control-align">
                            <div class="hover-wrapper"
                                (mouseenter)="showHoverCard='shipToLocation'"
                                (mouseleave)="showHoverCard=''">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="shipToLocation">
                                </mat-form-field>
                                @if(showHoverCard === 'shipToLocation' && canShowPopup('shipToLocation')) {
                                    <app-crm-entity-details-popup 
                                        [title]="getPopupTitle('shipToLocation')"
                                        [rows]="getPopupRows('shipToLocation')"
                                        class="hover-popup">
                                    </app-crm-entity-details-popup>
                                }
                            </div>
                            <button mat-raised-button color="primary" (click)="searchCustomer(CustomerSearchType.ShipToLocation)" [disabled]="isFormDisabled || customerAccountsDisabled || customerButtonStates.shipToLocation.searchDisabled">...</button>
                            <button mat-raised-button color="primary" (click)="verifyCustomer(CustomerSearchType.ShipToLocation)" [disabled]="isFormDisabled || customerAccountsDisabled || customerButtonStates.shipToLocation.verifyDisabled">{{'VERIFY' | translate}}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{'NAME' | translate}}:</div>
                        <div class="col-md-10">{{ shipToLocationData.customerName }}
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-2">
                    <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'BILL_TO' | translate}}</legend>
                    <div class="row">
                    <mat-checkbox [checked]="isApplySoldToChecked('billTO')" class="sold-to-checkbox" [disabled]="isBillToApplySoldToLocked || !hasSoldToAccountSelected()"
                    (change)="onApplySoldToChange('billTO', $event.checked)" color="primary">{{ 'APPLY_SOLD_TO_ACCOUNT' | translate }}</mat-checkbox>
                </div>
                <div class="row">
                        <div class="col-md-2">{{'ID' | translate}}:</div>
                        <div class="col-md-10 control-align">
                            <div class="hover-wrapper"
                            (mouseenter)="showHoverCard='billTO'"
                            (mouseleave)="showHoverCard=''">
                            <mat-form-field appearance="outline">
                                    <input matInput formControlName="billTO">
                            </mat-form-field>
                            @if(showHoverCard==='billTO' && canShowPopup('billTO')) {
                                <app-crm-entity-details-popup 
                                    [title]="getPopupTitle('billTO')"
                                    [rows]="getPopupRows('billTO')"
                                    class="hover-popup">
                                </app-crm-entity-details-popup>
                            }
                            </div>
                            <button mat-raised-button color="primary" (click)="searchCustomer(CustomerSearchType.BillToLocation)" [disabled]="isFormDisabled || customerAccountsDisabled || customerButtonStates.billTO.searchDisabled">...</button>
                            <button mat-raised-button color="primary" (click)="verifyCustomer(CustomerSearchType.BillToLocation)" [disabled]="isFormDisabled || customerAccountsDisabled || customerButtonStates.billTO.verifyDisabled">{{'VERIFY' | translate}}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{'NAME' | translate}}:</div>
                        <div class="col-md-10">{{ billToData.customerName }}
                        </div>
                    </div>
                </fieldset>
                <fieldset class="border rounded-3 p-2">
                    <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'END_USER' | translate}}</legend>
                    <div class="row">
                    <mat-checkbox [checked]="isApplySoldToChecked('endUser')" class="sold-to-checkbox" [disabled]="!hasSoldToAccountSelected()"
                    (change)="onApplySoldToChange('endUser', $event.checked)" color="primary">{{ 'APPLY_SOLD_TO_ACCOUNT' | translate }}</mat-checkbox>
                </div>
                <div class="row">
                        <div class="col-md-2">{{'ID' | translate}}:</div>
                        <div class="col-md-10 control-align">
                            <div class="hover-wrapper"
                            (mouseenter)="showHoverCard='endUser'"
                            (mouseleave)="showHoverCard=''">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="endUser">
                                </mat-form-field>
                                @if(showHoverCard==='endUser' && canShowPopup('endUser')) {
                                    <app-crm-entity-details-popup 
                                        [title]="getPopupTitle('endUser')"
                                        [rows]="getPopupRows('endUser')"
                                        class="hover-popup">
                                    </app-crm-entity-details-popup>
                                }
                            </div>
                            <button mat-raised-button color="primary" (click)="searchCustomer(CustomerSearchType.EndUser)" [disabled]="isFormDisabled || customerAccountsDisabled || customerButtonStates.endUser.searchDisabled">...</button>
                            <button mat-raised-button color="primary" (click)="verifyCustomer(CustomerSearchType.EndUser)" [disabled]="isFormDisabled || customerAccountsDisabled || customerButtonStates.endUser.verifyDisabled">{{'VERIFY' | translate}}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{'NAME' | translate}}:</div>
                        <div class="col-md-10">{{ endUserData.customerName }}
                        </div>
                    </div>
                </fieldset>
            </div>
            <div class="col-md-6">
                <fieldset class="border rounded-3 p-2">
                    <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'OPPORTUNITY' | translate}}</legend>
                    <div class="row">
                        <div class="col-md-4">{{'NAME' | translate}}:</div>
                        <div class="col-md-8">
                            <mat-form-field appearance="outline" class="w-100">
                                <input matInput formControlName="opportunityName" placeholder="{{'NAME' | translate}}">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">{{'DESCRIPTION' | translate}}:</div>
                        <div class="col-md-8">
                            <mat-form-field appearance="outline" class="w-100">
                                <textarea matInput formControlName="opportunityDescription" class="opportunity-description"
                                    placeholder="{{'DESCRIPTION' | translate}}"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-4">
                        <div class="col-md-4">{{'SALES_OFFICE' | translate}}:</div>
                        <div class="col-md-8">{{ salesOffice.value }}</div>
                    </div>
                    <div class="mb-4">
                        <fieldset class="border rounded-3 p-2">
                            <legend class="float-none w-auto px-1 font-size-13">{{ 'DEPTH_STRUCTURE' | translate}}</legend>
                            <div class="row">
                                <div class="col-md-4">{{'BUSINESS_LINE' | translate}}:</div>
                                <div class="col-md-8">{{ businessLine.value }}</div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">{{'SEGMENT' | translate}}:</div>
                                <div class="col-md-8">{{ segment.value }}</div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">{{'BUSINESS_HIERARCHY' | translate}}:</div>
                                <div class="col-md-8">{{ businessHierarchy.value}}</div>
                            </div>
                        </fieldset>
                    </div>
                    <div class="row">
                        <div class="col-md-4">{{'EXPECTED_BOOK' | translate}}:</div>
                        <div class="col-md-8">
                            <mat-form-field appearance="outline" class="widthForm">
                                <mat-label>{{ 'CHOOSE_DATE' | translate }}</mat-label>
                                <input class="mt-1" formControlName="expectedBook" matInput [matDatepicker]="picker">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">{{'SELL_AS' | translate}}:</div>
                        <div class="col-md-8">{{ sellAs.value | multilingualCurrency }}</div>
                    </div>
                    <div class="row d-flex align-items-center">
                        <div class="col-md-4">{{'VERTICAL_SALES_TEAM' | translate}}:</div>
                        <div class="col-md-8 ps-0">
                            @if (isChangeOrder) {
                                <mat-form-field appearance="outline" class="w-100">
                                    <input matInput formControlName="ecs" placeholder="{{'VERTICAL_SALES_TEAM' | translate}}">
                                </mat-form-field>
                            } @else {
                                <mat-radio-group formControlName="ecs">
                                    <mat-radio-button color="primary" value="Yes">{{'YES' | translate}}</mat-radio-button>
                                    <mat-radio-button color="primary" value="No">{{'NO' | translate}}</mat-radio-button>
                                </mat-radio-group>
                            }
                        </div>
                    </div>
                    <div class="row d-flex align-items-center">
                        <div class="col-md-4">{{'RESTRICTED_TYPE' | translate}}:</div>
                        <div class="col-md-8 ps-0">
                            @if (isChangeOrder) {
                                <mat-form-field appearance="outline" class="w-100">
                                    <input matInput
                                           [value]="(createOpportunityFormGroup.controls.restrictionType.value === 'restricted' ? 'RESTRICTED' : 'UNRESTRICTED') | translate"
                                           disabled>
                                </mat-form-field>
                            } @else {
                                <mat-radio-group formControlName="restrictionType">
                                    <mat-radio-button color="primary" value="restricted">{{'RESTRICTED' |
                                        translate}}</mat-radio-button>
                                    <mat-radio-button color="primary" value="unrestricted">{{'UNRESTRICTED' |
                                        translate}}</mat-radio-button>
                                </mat-radio-group>
                            }
                        </div>
                    </div>
                    @if (canShowFederalFundedSection) {
                    <div class="mb-4">
                        <fieldset class="border rounded-3 p-2">
                            <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'FEDERAL_FUNDED' | translate}}</legend>
                            <div class="row d-flex align-items-center">
                                <div class="col-md-4">{{'GOVERNMENT_ENTITY' | translate}}:</div>
                                <div class="col-md-8">
                                    <mat-form-field class="w-100">
                                        <mat-select formControlName="governmentEntity">
                                            @for (item of entityItems; track item.value) {
                                            <mat-option [value]="item.value">{{item.label}}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row d-flex align-items-center">
                                <div class="col-md-4">{{'GOVERNMENT_AGENCY' | translate}}:</div>
                                <div class="col-md-8">
                                    <mat-form-field class="w-100">
                                        <mat-select formControlName="governmentAgency">
                                            @for (item of agencyItems; track item.value) {
                                            <mat-option [value]="item.value">{{item.label}}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row d-flex align-items-center">
                                <div class="col-md-4">{{'BUY_AMERICAN' | translate}}:</div>
                                <div class="col-md-8 ps-0">
                                    <mat-radio-group formControlName="buyAmerican">
                                        <mat-radio-button color="primary" value="Yes"
                                            [disabled]="!buyAmericanState.yesEnabled">{{'YES' |
                                            translate}}</mat-radio-button>
                                        <mat-radio-button color="primary" value="No"
                                            [disabled]="!buyAmericanState.noEnabled">{{'NO' | translate}}</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="row d-flex align-items-center">
                                <div class="col-md-4">{{'CONTACT_SCHEDULE' | translate}}:</div>
                                <div class="col-md-8">
                                    <mat-form-field class="w-100">
                                        <mat-select formControlName="contractSchedule">
                                            @for (item of contractScheduleItems; track item.value) {
                                            <mat-option [value]="item.value">{{item.label}}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row d-flex align-items-center">
                                <div class="col-md-4">{{'DEFENSIVE_PRIORITIES' | translate}}:</div>
                                <div class="col-md-8 ps-0">
                                    <mat-radio-group formControlName="defensivePriorities">
                                        <mat-radio-button color="primary" value="Yes"
                                            [disabled]="!dpasState.yesEnabled">{{'YES' |
                                            translate}}</mat-radio-button>
                                        <mat-radio-button color="primary" value="No"
                                            [disabled]="!dpasState.noEnabled">{{'NO' | translate}}</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="row d-flex align-items-center">
                                <div class="col-md-4">{{'CUI_LEVEL' | translate}}:</div>
                                <div class="col-md-8 ps-0">
                                    <mat-radio-group formControlName="cmmc">
                                        <mat-radio-button color="primary" value="Level 1 - FCI"
                                            [disabled]="!cmmcState.fciEnabled">{{'LEVEL_1_FCI' |
                                            translate}}</mat-radio-button>
                                        <mat-radio-button color="primary" value="Level 2 - CUI"
                                            [disabled]="!cmmcState.cuiEnabled">{{'LEVEL_2_CUI' |
                                            translate}}</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    }
                </fieldset>
            </div>
        </div>
    </div>
    <div class="dialog-footer  d-flex justify-content-end">
        <!-- TODO: Help button click handler not yet implemented -->
        <button mat-raised-button color="primary">{{'HELP' | translate}}</button>
        <button mat-raised-button color="primary" [disabled]="!canCreate || isCreating" (click)="createOpportunity()">{{'CREATE' | translate}}</button>
        <button mat-raised-button color="warn" [disabled]="isCreating"
        (click)="cancelChanges()">{{'CANCEL_BTN_LABEL'| translate}}</button>
    </div>
</div>
